import React, {useEffect, useState} from 'react';
import ReservationMaterialTable from "../../../../components/UI/table/warehouse/reservation/ReservationMaterialTable";
import MaterialReserveService from "../../../../API/orders/reservation/MaterialReserveService";
import {EditLocalStoragePagesData} from "../../../../utils/EditLocalStoragePagesData";
import {Box} from "@mui/system";
import {BreadcrumbsComponent} from "../../../../components/UI/breadcrumb/BreadcrumbComponent";
import Typography from "@mui/material/Typography";
import ModalAlert from "../../../../components/UI/table/customer-detales/ModalAlert";
import {constantsErrorMessages} from "../../../../Constants";
import {calcFilterData} from "../../../../utils/common/calcFilterData";
import {ReservationMaterialTableFilterData} from "../../../../data/FilterTables/ReservationMaterialTableFilterData";
import DetailUtil from "../../../../utils/cutting/DetailUtil";
import OrderUtil from "../../../../utils/orders/OrderUtil";
import {materialReserveState} from "../../../../data/MaterialReserveState";
import CircularProgress from "@mui/material/CircularProgress";

const ReservationPieceMaterial = () => {
    const [data, setData] = useState([]);
    const [change, setChange] = useState(null);
    const [alertData, setAlertData] = useState({});
    const [filteredData, setFilteredData] = useState(data)
    const [globalFilter, setGlobalFilter] = useState('');
    const [columnsFilter, setColumnsFilter] = useState([]);
    const [warningIds, setWarningIds] = useState([]);
    const [statusList, setStatusList] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(`organization/reservation-piece-material`, "pageSize", nextState.pageSize)
        }
    }
    const handleSearchQuery = (searchQuery, prevData, pageSize, isColumnFilters) => {
        const newColumnsFilter = isColumnFilters ? searchQuery : columnsFilter
        const newGlobalFilter = isColumnFilters ? globalFilter : searchQuery || ""

        const data = [...prevData]
        const globalFilterData = newGlobalFilter ? calcFilterData(data, newGlobalFilter, ReservationMaterialTableFilterData) : data
        const newData = newColumnsFilter.reduce((accumulator, currentValue) => {
            return calcFilterData(accumulator, currentValue?.value, [ReservationMaterialTableFilterData.find(el => el.idFromColumnFilter === currentValue.id)])
        }, globalFilterData);

        setFilteredData(newData)

        tableOptionsHandle({
            ...tableOptions,
            totalElements: newData.length,
            pageSize: pageSize ? pageSize : tableOptions?.pageSize
        })

        if (isColumnFilters) {
            setColumnsFilter(searchQuery)
        } else {
            setGlobalFilter(searchQuery || "")
            if (searchQuery !== globalFilter) {
                EditLocalStoragePagesData(`organization/reservation-piece-material`, "searchQuery", searchQuery)
            }
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[`organization/reservation-piece-material`]?.pageSize
        const searchQuery = pagesData[`organization/reservation-piece-material`]?.searchQuery

        return {searchQuery, pageSize}
    }
    const calcWarningString = (data) => {
        const warning = DetailUtil.checkDuplicateNamesAndOrder(data);
        if (warning.length > 0) {
            setWarningIds(warning)
        }
    }

    useEffect(() => {
        const {searchQuery, pageSize} = getStartPageSize()
        MaterialReserveService.getAllNotArchivePieceMaterial().then(function (response) {
            let data = response.data;
            setStatusList(OrderUtil.getListFieldByEnum(data, 'materialReserveState', materialReserveState));
            setData(data);
            calcWarningString(data)
            handleSearchQuery(searchQuery, data, pageSize)
        })
            .catch(function (error) {
                handleModalAlert(error);
            }).finally(() => setIsLoading(false))
    }, [change]);

    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={"Резервирование фурнитуры"}
                path={[
                    {name: "Главная", href: "/"},
                ]}/>
            <Box sx={{display: "flex", flexDirection: "column"}}>
                <Box sx={{display: "flex", flexDirection: "column"}}>
                    <Typography component="p" sx={{fontSize: "24px", fontWeight: 700}}>
                        Резервирование фурнитуры
                    </Typography>
                </Box>
                {isLoading ?
                    <Box sx={{
                        height: `calc(100vh - 450px)`,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}>
                        <CircularProgress disableShrink/>
                    </Box> :<ReservationMaterialTable
                    data={data}
                    setData={setData}
                    pageSize={100}
                    enableGrouping={true}
                    columnGrouping={["materialName"]}
                    expanded={false}
                    isColumnMaterialWarehouse={false}
                    isColumnOptimization={false}
                    change={change}
                    setChange={setChange}
                    titleModalUpdateOrAddMaterialArrival={"Создать приход штучных материалов"}
                    typeMaterial={'PIECE'}
                    tableOptions={tableOptions}
                    tableOptionsHandle={tableOptionsHandle}
                    handleModalAlert={handleModalAlert}
                    globalFilter={globalFilter}
                    filteredData={filteredData}
                    handleSearchQuery={handleSearchQuery}
                    columnsFilter={columnsFilter}
                    warningIds={warningIds}
                    statusList={statusList}
                    calcWarningString={calcWarningString}
                />}
                <ModalAlert
                    data={alertData}
                    onClose={() => setAlertData((alert) => ({...alert, open: false}))}
                />
            </Box>
        </Box>
    );
};

export default ReservationPieceMaterial;